import React from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUsaChart } from "./usaChartsSlice";
import { fetchUsaChart } from "./usaChartsSlice";
import { useParams } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import styles from "./usaCharts.module.css";

function UsaCharts() {
  const selectedState = useParams().state;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchUsaChart(selectedState));
  }, [dispatch, selectedState]);

  const info = useSelector(selectUsaChart);

  const sourceCases = info.cases;
  const sourceDeaths = info.deaths;
  const sourceDate = info.date;

  const data = {
    labels: sourceDate,
    datasets: [
      {
        label: "Cases",
        data: sourceCases,
        borderColor: "rgba(33, 150, 243, 1)",
        borderWidth: 1,
        backgroundColor: "rgba(33, 150, 243, 0.6)",
      },
      {
        label: "Deaths",
        data: sourceDeaths,
        borderColor: "rgba(255, 87, 34, 1)",
        borderWidth: 1,
        backgroundColor: "rgba(255, 87, 34, 0.6)",
      },
    ],
  };

  const container = {
    minHeight: "80vh",
    width: "100vw",
    display: "flex",
    flexWrap: "wrap",
    alignContent: "center",
    justifyContent: "center",
  };

  const graphBox = {
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "30px",
  };

  if (info.error) {
    return <p>{info.error}</p>;
  }

  if (info.isLoading) {
    return (
      <div className={styles.loading}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div style={container}>
      {
        <Link to={"/usa"}>
          <div style={{ alignSelf: "flex-start" }}>
            <ArrowBackIosIcon fontSize="small" />
          </div>
        </Link>
      }
      {
        <div>
          {<div>Graph for {info.usState}</div>}
          {
            <div style={{ textAlign: "center" }}>
              Click the legend below to isolate records
            </div>
          }
        </div>
      }

      <div style={graphBox}>
        <Bar data={data} />
      </div>
    </div>
  );
}

export default UsaCharts;
